import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ChargeInterface } from "../../Entity/Entities/Charge/ChargeInterface";
import ChargeFactory from "../../Entity/Factories/ChargeFactory";
import Translator from "../../Translation/Translator";

export default function* chargeCreate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CHARGE_CREATE_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_CHARGE_CREATE_REQUEST
    });

    var res;
    if( action.payload.variation && action.payload.variation === 'settle-bill') {
      res = yield call(Http.post, `charge/settle-bill`, {
        ...action.payload?.charge
      })
    } else {
      res = yield call(Http.post, `charge`, {
      ...action.payload?.charge
      })
    }

    const charge: ChargeInterface = ChargeFactory.create(res.data.data);

    yield put({
      type: Constants.GLOBAL_CHARGE_CREATE_SUCCESS
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-charge-created-successfully"),
        type: "success"
      }
    });

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, charge);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CHARGE_CREATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchChargeCreate() {
  yield takeEvery(Constants.GLOBAL_CHARGE_CREATE_START, chargeCreate);
}
